import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import logoNoBg from "../images/logoNoBg.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    emailjs
      .sendForm("service_01k8y3k", "template_g120k56", form.current, {
        publicKey: "gvagGh8hnkaSQX3iD",
      })
      .then(
        () => {
          console.log("SUCCESS!");

          // Show success toast
          toast.success("Message sent successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });

          setFormData({
            name: "",
            phone: "",
            email: "",
            message: "",
            consent: false,
          });

          // Reset the actual form element
          form.current.reset();
        },
        (error) => {
          console.log("FAILED...", error.text);
          // Show error toast
          toast.error("Failed to send message. Please try again.", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      );
  };

  return (
    <div className="w-full">
      {/* Get in Touch Form */}
      <section className="py-12 px-4 max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold mb-2 text-center">Get in Touch</h2>

        <form ref={form} className="space-y-6" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name *"
            value={formData.name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone *"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email *"
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            required
          />

          <textarea
            name="message"
            placeholder="How can I help you? *"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300"
            required
          ></textarea>

          {/* Terms Checkbox */}
          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
              className="mt-1"
              required
            />
            <label className="text-sm text-gray-600">
              I consent to receive text messages from Winik Properties LLC.
              Messages sent may include rental payment reminders, maintenance
              scheduling, property updates, and community notices. Message
              frequency will vary depending on service needs, with maintenance
              notifications as required, rental reminders typically 3–5 days
              before due dates, and urgent property updates sent as needed.
              Message and data rates may apply. Reply HELP or contact us at{" "}
              <a
                href="mailto:contact.winikproperties@gmail.com"
                className="text-blue-600 underline"
              >
                contact.winikproperties@gmail.com
              </a>{" "}
              for support. Reply STOP to opt out of future messages at any time.
              See our{" "}
              <Link to="/privacy-policy" className="text-blue-600 underline">
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link
                to="/terms-and-conditions"
                className="text-blue-600 underline"
              >
                Terms of Use
              </Link>{" "}
              for more information.
            </label>
          </div>

          <button
            type="submit"
            className="bg-[#0f3654] text-white px-6 py-2 rounded-md hover:bg-[#0d2d46] transition"
          >
            Submit
          </button>
        </form>
      </section>

      {/* Address */}
      <section className="relative">
        <div className="w-full h-[500px] bg-[#0f3654]"></div>
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl flex flex-col items-center justify-center">
            <div className="mb-[10px]">
              <img src={logoNoBg} width={80} alt="Winik Properties Logo" />
            </div>
            <div>
              <h2 className="text-3xl font-bold mb-6 text-white">
                Get in touch!
              </h2>
              <p className="mb-2 text-white">
                E-mail us at:{" "}
                <a
                  href="mailto:contact.winikproeprties@gmail.com"
                  className="underline"
                >
                  contact.winikproeprties@gmail.com
                </a>
              </p>
              <p className="mb-2 text-white">Call us at: +1 (727) 405 1863</p>
              <p className="text-white">
                Location: 7901 4th St N Ste 300, St Petersburg, FL 33702
              </p>
              <div className="mt-6 font-semibold text-white">
                Winik Properties LLC
              </div>
            </div>
            {/* <div className="flex items-center justify-center text-sm gap-4 py-4 text-white">
              <Link to="/privacy-policy" className="hover:underline">
                Privacy Policy
              </Link>
              <div>|</div>
              <Link to="/terms-and-conditions" className="hover:underline">
                Terms and Conditions
              </Link>
            </div> */}
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
